import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";
import FilteredTable from "../../FilteredTable.js";
import pricing from '../../../assets/Data/pricingData';

const fastertime = require("../../../assets/icons-pack/6.4 SAP Hana/ic_01_fastertime.svg");
const scalibility = require("../../../assets/icons-pack/6.4 SAP Hana/ic_02_scalibility.svg");
const costeffect = require("../../../assets/icons-pack/6.4 SAP Hana/ic_03_costeffect.svg");
const highavailiblity = require("../../../assets/icons-pack/6.4 SAP Hana/ic_04_highavailiblity.svg");
const flexibility = require("../../../assets/icons-pack/6.4 SAP Hana/ic_05_flexibility.svg");
const highavailibility = require("../../../assets/icons-pack/6.4 SAP Hana/ic_06_highavailibility.svg");
const optionalfeatures = require("../../../assets/icons-pack/6.4 SAP Hana/ic_07_optionalfeatures.svg");

function SAPHana() {
    const heading = `SAP® HANA `;
    const details = `Use the huge capabilities of SAP HANA in your cloud. `;

    const overview = [
        `DETASAD provides SAP customers with SAP-certified cloud infrastructure to run SAP HANA DATABASE. With DETASAD, SAP HANA environment can be rapidly provisioned without any capital investments or long-term commitments. SAP HANA on DETASAD Cloud can be deployed on either Red Hat Enterprise Linux (RHEL) or other Linux-based operating system.`
    ];

    const advantages = [
        [
            `Faster Time `,
            `Accomplish faster time - to provision infrastructure for Oracle in hours versus weeks to months. `,
            fastertime
        ],
        [`Scalability`, `Scale infrastructure resources – as your data requirements`, scalibility],
        [
            `Cost Effective `,
            `Decrease cost - by paying for only the infrastructure assets and resources that you need and use. `,
            costeffect
        ],
        [
            `Flexibility`,
            `Bring your own license – leverage your existing licensing investment with no extra licensing fees. Pay for the licenses monthly on leasing model. `,
            flexibility
        ],
        [
            `High Availability `,
            `DB Incident Management. Configuration Management. Patch management. Interfacing with Database vendors. DB security patches management in coordination with the Customer. `,
            highavailiblity
        ],
        [
            `Database Monitoring `,
            `Database processes. Database response time. 24x7x365 monitoring. Proactive notification `,
            highavailibility
        ]
    ];
    // let TablesData = []
    // pricing.map(price => {
    //     price.price = parseFloat(price.price).toFixed(2);
    //     if(price.name.includes('SAP') ){
    //         console.log(price,'price')
    //         price['hourlyPricing'] = (price.price / 720).toFixed(2)
    //         price['monthlyPricing'] = price.price
    //         TablesData.push(price) 
    //     }
    // })
    let TablesData = []
    pricing.map(price => {
        price.price = parseFloat(price.price).toFixed(2);
        if(price.name.includes('HANA') &&  price.mod){
            console.log(price,'price')
            price['hourlyPricing'] = (price.price / 720).toFixed(2)
            price['monthlyPricing'] = price.price
            TablesData.push(price) 
        }
    })
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-database"/>
            <SubNav overview={overview} advantages={advantages} FilteredTable={FilteredTable} filteredData = {TablesData} />
            <Footer />
        </div>
    );
}

export default SAPHana;
